// extracted by mini-css-extract-plugin
module.exports = {"layout":"_21620d3522--layout--c1cnT"};